import { Redirect, useLocation } from "react-router-dom";

import { useUser } from "@/hooks/useUser";

export const OrgRedirectView = () => {
  const { data } = useUser();
  const { default_organization = null } = data?.ok ? data.data : {};
  const { pathname, search } = useLocation();

  if (default_organization?.uuid && pathname) {
    return (
      <Redirect
        to={
          pathname.replace("/a/", `/a/${default_organization.uuid}/`) + search
        }
      />
    );
  }

  return null;
};
